import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { nbsApiSetNewPassword } from '../../../../store/actions/setNewPassword';

import Auxi from '../../../../hoc/Auxi/Auxi';
import PropsRoute from '../../../../hoc/PropsRoute/PropsRoute';
import IndexPage from '../../../IndexPage/IndexPage';
import NewPassword from '../../../../components/Auth/PasswordRecovery/NewPassword/NewPassword';
import paths from '../../../../constants/paths';
import strings from '../../../../assets/localization';

class NewPasswordContainer extends Component {
  state = {
    password: '',
    showAlert: false,
    errorMessage: '',
    newPasswordSet: false,
  };

  componentDidMount() {
    // Validate if token exists, otherwise close the component
    if (!this.props.computedMatch.params.token) {
      this.close();
    }
  }

  componentDidUpdate(prevProps) {
    // Handle error updates
    if (
      this.props.setNewPassword.error !== prevProps.setNewPassword.error &&
      this.props.setNewPassword.error !== null
    ) {
      const errorMsg =
        this.props.setNewPassword.error.error ||
        this.props.setNewPassword.error.message;

      this.setState({
        errorMessage: errorMsg,
        showAlert: !!errorMsg,
      });
    }

    // Handle successful password reset
    if (
      this.props.setNewPassword.response.success &&
      prevProps.setNewPassword.response.success !==
        this.props.setNewPassword.response.success
    ) {
      this.setState({
        newPasswordSet: true,
        showAlert: true,
        errorMessage: strings.NewPasswordSet,
      });
    }
  }

  close = () => {
    this.props.history.replace(paths.INDEX);
  };
  setPassword = (password) => {
    this.setState({ password });
  };
  submitNewPassword = () => {
    this.props.nbsApiSetNewPassword({
      restore_token: this.props.computedMatch.params.token,
      new_password: this.state.password,
    });
  };
  toggleAlertError = () => {
    this.setState({ showAlert: !this.state.showAlert });
    if (this.state.newPasswordSet === true) {
      this.props.history.replace(paths.LOGIN);
    }
  };

  render() {
    return (
      <Auxi>
        {this.props.isLandscape ? (
          <PropsRoute component={IndexPage} isLandscape />
        ) : null}
        <NewPassword
          isLandscape={this.props.isLandscape}
          setPassword={this.setPassword}
          password={this.state.password}
          showSpinner={this.props.setNewPassword.isFetching}
          close={this.close}
          submitNewPassword={this.submitNewPassword}
          showErrorAlert={this.state.showAlert}
          toggleAlertError={this.toggleAlertError}
          emailErrorMessage={this.state.errorMessage}
        />
      </Auxi>
    );
  }
}

function mapStateToProps(state) {
  return {
    setNewPassword: state.setNewPassword,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ nbsApiSetNewPassword }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewPasswordContainer);



// WEBPACK FOOTER //
// ./src/containers/Auth/PasswordRecovery/NewPassword/NewPasswordContainer.js